export default __webpack_public_path__ + "static/media/ColorfulLogo.0a1585fc.svg";